import { Transforms } from 'slate';
import { Type } from '../types.mjs';
import { isElement } from '../../../../../core/utilities/nodes/elements/isElement.mjs';

function unwrapLinks(editor, at = editor.selection) {
  if (!at) {
    return;
  }
  Transforms.unwrapNodes(editor, {
    at,
    match: node => isElement(node) && node.type === Type
  });
}

export { unwrapLinks };
